import { render, staticRenderFns } from "./ticketPrice.vue?vue&type=template&id=575e8b91&scoped=true&"
import script from "./ticketPrice.vue?vue&type=script&lang=js&"
export * from "./ticketPrice.vue?vue&type=script&lang=js&"
import style0 from "./ticketPrice.vue?vue&type=style&index=0&id=575e8b91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e8b91",
  null
  
)

export default component.exports